import { chakra, Stack, Box } from "@chakra-ui/react"
import { space } from "theme/themeConfig"

export const Container = chakra(Stack, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    pt: space[3],
  },
})

export const PriceBreakdownContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    py: 0,
    mt: "0 !important",
  },
})
